/**
 * dav app 的hook，用户登录hook，用户登录时触发事件
 */
import EventBus, { EventTypes } from '@common/utils/event-bus';

export default function userLoginHook() {
  return () => (next) => (action) => {
    if (!action) {
      return next(action);
    }

    // 需要try-catch,避免emitter事件监听器中抛出的异常，引起dva崩溃
    try {
      const { type = '', payload = {} } = action;
      if (type === 'user/saveCurrentUser') {
        // 触发用户登录事件
        EventBus.emitter.emit(EventTypes.USER_LOGIN, payload);
      }
    } catch (err) {
      /** noop */
    }
    return next(action);
  };
}
